<template>
	<el-dialog append-to-body class="custom-nested-dialog request-type-step-dialog" :title="title" :before-close="handleBeforeCloseDialog" :visible.sync="isDialogActiveLocal">
		<PerfectScrollbar>
			<RequestNotificationStepsConfig
				class="form request-type-step-dialog__form p-6"
				ref="requestTypeConfigRef"
				v-model="value"
				:isEditable="isEditable"
				:isRequiredName="true"
				:isRequiredConfig="true"
			/>
		</PerfectScrollbar>

		<div slot="footer" class="flex items-center sm:px-12 justify-center">
			<vs-button @click.stop="submitData" class="w-full sm:w-2/5 font-bold">{{ $t("Actions.Save") }}</vs-button>
		</div>
	</el-dialog>
</template>

<script>
import _ from "lodash";

import RequestNotificationStepsConfig from "@/components/cbs-request-notification-steps-config/RequestNotificationStepsConfig";

export default {
	name: "RequestTypeStepDialog",
	components: { RequestNotificationStepsConfig },
	provide() {
		return { parentValidator: this.$validator };
	},
	props: {
		value: {
			type: Object,
			required: true
		},
		isDialogActive: {
			type: Boolean,
			required: true
		},
		title: {
			type: String,
			required: true
		},
		isEditable: {
			type: Boolean,
			default: false
		}
	},
	emits: {
		closeDialog: {
			required: true
		},
		onSubmit: {
			required: true
		}
	},
	data() {
		return {
			initFormData: {},
			isFormDirty: false
		};
	},
	computed: {
		isDialogActiveLocal: {
			get() {
				return this.isDialogActive;
			},
			set(val) {
				if (!val) {
					this.$emit("closeDialog");
				}
			}
		}
	},
	watch: {
		isDialogActive(val) {
			if (!val) return;

			if (!this.value) {
				this.initValues();
			}
		},
		value: {
			handler: function() {
				this.isFormDirty = JSON.stringify(this.value) !== JSON.stringify(this.initFormData);
			},
			deep: true
		}
	},
	methods: {
		initValues() {
			this.isFormDirty = false;
		},
		submitData() {
			this.$validator.validateAll().then(result => {
				if (result) {
					this.$emit("onSubmit");
				} else {
					// set active closest error tab
					const listTabNames = ["approverConfig", "approvedNotificationConfig", "rejectedNotificationConfig"];
					let listErrorFields = _.get(this.$validator, "errors.items") || [];
					if (!_.isEmpty(listErrorFields)) {
						listErrorFields = listErrorFields.some(errorField => {
							const splitErrorFormName = errorField.field.split("-")[0];
							const index = listTabNames.findIndex(val => val === splitErrorFormName);
							if (index !== -1 && this.$refs.requestTypeConfigRef && this.$refs.requestTypeConfigRef.$children && this.$refs.requestTypeConfigRef.$children[1]) {
								this.$refs.requestTypeConfigRef.$children[1]._data.activeIndex = index;
								return true;
							}
						});
					}
				}
			});
		},
		handleBeforeCloseDialog(setDialogHide) {
			this.handleCloseDialog(() => {
				this.initValues();
				setDialogHide();
			}, this.isFormDirty);
		}
	},
	created() {
		this.initFormData = _.cloneDeep(this.value);
	}
};
</script>
